import { render, staticRenderFns } from "./SavedDownloadSettingsTab.vue?vue&type=template&id=04f3d338&scoped=true"
import script from "./SavedDownloadSettingsTab.vue?vue&type=script&lang=js"
export * from "./SavedDownloadSettingsTab.vue?vue&type=script&lang=js"
import style0 from "./SavedDownloadSettingsTab.vue?vue&type=style&index=0&id=04f3d338&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3d338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f3d338')) {
      api.createRecord('04f3d338', component.options)
    } else {
      api.reload('04f3d338', component.options)
    }
    module.hot.accept("./SavedDownloadSettingsTab.vue?vue&type=template&id=04f3d338&scoped=true", function () {
      api.rerender('04f3d338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/Export/SavedDownloadSettingsTab.vue"
export default component.exports